import React, { useState } from 'react';
import './contact.css';
import { HiOutlineMail } from "react-icons/hi";
import { BsLinkedin } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";
import { AiOutlineFilePdf } from "react-icons/ai";
import ResumeDialog from './ResumeDialog';
import resumePDF from '../../assets/resumeAbi.pdf';

const Contact = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <section id='contact'>
      <h5>Get in Touch</h5>
      <h2>Contact me</h2>

      <div className="container contact__container">
        <div className="contact__options">
            <article className="contact__option">
              <HiOutlineMail className='contact__option-icon' />
              <h4>Email</h4>
              <h5>abijacob92@gmail.com</h5>
              <a href="mailto:abijacob92@gmail.com" target="_blank" rel="noopener noreferrer">Send an Email</a>
            </article>

            <article className="contact__option">
              <BsLinkedin className='contact__option-icon' />
              <h4>LinkedIn</h4>
              <h5>linkedin.com/in/abi-jacob/</h5>
              <a href="https://www.linkedin.com/in/abi-jacob/" target="_blank" rel="noopener noreferrer">Connect on LinkedIn</a>
            </article>

            <article className="contact__option">
              <FaGithub className='contact__option-icon' />
              <h4>GitHub</h4>
              <h5>github.com/abijacob</h5>
              <a href="https://github.com/abijacob" target="_blank" rel="noopener noreferrer">View my projects</a>
            </article>

            <article className="contact__option" onClick={openModal} style={{cursor: 'pointer'}}>
              <AiOutlineFilePdf className='contact__option-icon' />
              <h4>Resume</h4>
              <h5>My Professional Profile</h5>
              <span className="contact__option-link">View/Download</span>
            </article>
        </div>

        <form action=""></form>
      </div>

      <ResumeDialog show={isModalOpen} onClose={closeModal} pdfUrl={resumePDF} />
    </section>
  )
}

export default Contact;